import React, { useEffect, useState } from 'react';
import '../css/TopBar.css';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { patientTopbarOptions, topbarOptions } from '../constant/Constant';
import { cufrontLogos } from '../../../../cufront-assets/logos/Logos';
import SidebarItem from './SidebarItem';
import { clinicAtom } from '../../../../_helper/constant/constant-atom';
import { useAtom } from 'jotai';
import { useCurrentRole } from '../../../../_helper/constant/Permission';
import CuDropdown from '../../../../common_component/component/CuDropdown';
import { getImageURLwithouttoken } from '../../../../_helper/utils/image';
import MobileModal from '../../../../new_appointment/appoinment/components/MobileModal';
import { MobileModalBody } from '../../../../new_appointment/appoinment/components/MobileModalBody';

import { GiHamburgerMenu } from 'react-icons/gi';
import { RiLogoutBoxRFill } from 'react-icons/ri';
import { Logout } from '../../../../_helper/constant/auth';
import { IoArrowBack } from 'react-icons/io5';
import '../css/Sidebar.css';

const TopBar = ({ userRole }) => {
  const navigateTo = useNavigate();
  const [selectedClinic, setSelectedClinic] = useAtom(clinicAtom);
  const { bhp_registered_clinic } = useCurrentRole();
  const [clinicToggle, setClinicToggle] = useState(false);
  const [clinicOptions, setClinicOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const paramValue = searchParams.get('option');
  const mainColorStyle = { backgroundColor: 'var(--main-color)' };

  const openModal = () => setIsOpen(true);

  const closeModal = () => {
    setIsOpen(false);
    // setSelectedClinic(false);
  };

  useEffect(() => {
    if (bhp_registered_clinic) {
      const options = bhp_registered_clinic?.map(
        ({ bhp_registered_clinic_id: clinic }) => ({
          key: clinic?.id,
          value: clinic?.id,
          text: clinic?.clinic_name,
        }),
      );
      setClinicOptions(options);
    }
  }, [bhp_registered_clinic]);

  const handleSelectClinic = (value) => {
    const selectclinic = bhp_registered_clinic?.find(
      ({ bhp_registered_clinic_id: clinic }) => clinic?.id === value,
    );
    setSelectedClinic({
      id: selectclinic?.bhp_registered_clinic_id?.id,
      name: selectclinic?.bhp_registered_clinic_id?.clinic_name,
      isClinicLogo: selectclinic?.bhp_registered_clinic_id?.LOGO ? true : false,
      BHARATHEALPOINT_LOGO: getImageURLwithouttoken(
        selectclinic?.bhp_registered_clinic_id?.LOGO,
      ),
    });
  };

  const navigateHandler = (route) => {
    navigateTo(route);
    setIsOpen(!isOpen);
  };

  const handleClinicSelect = (clinic) => {
    setSelectedClinic(clinic);
    localStorage.setItem('clinic', clinic?.id);
    setClinicToggle(false);
  };

  return (
    <>
      <div className="top-bar-main">
        {location?.pathname === `/new/patient-options` && paramValue ? (
          <IoArrowBack
            className="-ml-[10px]"
            size={25}
            onClick={() => navigateTo(-1)}
          />
        ) : (
          <div
            className="top-bar-cufrontlogo"
            onClick={() => setClinicToggle(true)}
          >
            <img src={cufrontLogos.cufrontLogomark} />
          </div>
        )}
        <span>{selectedClinic?.clinic_name}</span>
        <div className="top-bar-notifications">
          <GiHamburgerMenu size={'24px'} onClick={openModal} />
        </div>
      </div>
      <MobileModal
        modalClassName={'modal-container-top-right'}
        isOpen={isOpen}
        closeModal={closeModal}
      >
        <MobileModalBody>
          <div
            className="flex items-center p-4 gap-2"
            onClick={() => setClinicToggle(!clinicToggle)}
          >
            {selectedClinic?.logo ? (
              <div className="w-[40px] h-[40px] rounded-full cursor-pointer">
                <img
                  src={selectedClinic?.logo}
                  alt="Company Logo"
                  className="logo-img w-full h-full"
                />
              </div>
            ) : (
              <div
                className="logo-img cursor-pointer w-[40px] h-[40px] border rounded-full flex justify-center items-center font-bold"
                style={mainColorStyle}
              >
                {selectedClinic?.clinic_name?.split('')[0]}
              </div>
            )}
            <div>
              <p>{selectedClinic?.clinic_name?.toUpperCase()}</p>
            </div>

            <div className="ml-auto">
              <span style={{ cursor: 'pointer' }} className="">
                ⋮
              </span>
            </div>
          </div>

          {clinicToggle && (
            <div className="clinic-div">
              <ul className="py-1 text-sm text-gray-700">
                {bhp_registered_clinic?.map((clinic) => {
                  return (
                    <div key={clinic?.id} className="clinic-div-item">
                      {clinic?.logo ? (
                        <div className="w-[40px] h-[40px] rounded-full overflow-hidden">
                          <img
                            src={clinic?.logo}
                            alt={`clinic logo...`}
                            className="w-full h-full "
                          />
                        </div>
                      ) : (
                        <div
                          className="w-[40px] h-[40px] border rounded-full flex justify-center items-center font-bold"
                          style={mainColorStyle}
                        >
                          {clinic?.clinic_name.split('')[0]}
                        </div>
                      )}
                      <li
                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                          clinic?.id === selectedClinic?.id ? 'text-black' : ''
                        }`}
                        onClick={() => handleClinicSelect(clinic)}
                      >
                        {clinic?.clinic_name}
                      </li>
                    </div>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="w-full mx-auto p-8 m-1">
            <>
              {topbarOptions?.map((ele) => (
                <div
                  onClick={() => navigateHandler(ele.route)}
                  className="flex items-center gap-7 py-5 cursor-pointer"
                >
                  <div className="">{ele?.inactiveIcon}</div>
                  <div className="text-lg font-semibold text-[#999999]">
                    {ele?.name}
                  </div>
                </div>
              ))}

              <div
                onClick={() => {
                  Logout();
                  navigateHandler('/login');
                }}
                className="py-5 pt-[11.5rem] flex gap-7 items-center"
              >
                <RiLogoutBoxRFill size={'25px'} color="#999999" />

                <div className="text-lg font-semibold  text-[#999999]">
                  Logout
                </div>
              </div>
            </>
          </div>
        </MobileModalBody>
      </MobileModal>
    </>
  );
};

export default TopBar;
